import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllAds } from '../../../redux/action/ads/getAds'
import default_image_url from '../../../redux/api/API'
import Wrapper from '../../homeWrapper/Wrapper'
import Announcements from './announcements/Announcements'
import Categories from './categories/Categories'
import ContactUs from './contactUs/ContactUs'
import ExpoLink from './expoLink/ExpoLink'
import Gallery from './gallery/Gallery'
import Header from './header/Header'
import MostViewedCompanies from './most-viewed-companies/MostViewedCompanies'
import NewestCompanies from './newest-companies/NewestCompanies'
import News from './news/News'
import './style.scss'

const Home = () => {
    const [ads, setAds] = useState([])
    const dispatch = useDispatch()
    const all_ads = useSelector(state => state.all_ads)

    useEffect(() => {
        if (!all_ads.all_ads.length) {
            dispatch(fetchAllAds())
        }
    }, [])
  
    useEffect(() => {
      setAds(all_ads.all_ads)
    }, [all_ads.all_ads])

    return (
        <Wrapper>
            <Helmet>
                <title> نمایشگاه مجازی</title>
            </Helmet>
            <Header />
            <Categories />

            {ads.length ?
            <Container>
                <div className='homepage-full-size-ad my-5'>
                    {ads.filter(item => item.location === 'homepage' & item.position === 'top-right').map(ad => (
                        <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='full-size-ad-container'>
                            <img src={default_image_url+ad.path} alt={ad.url} />
                        </a>
                    ))}
                    {ads.filter(item => item.location === 'homepage' & item.position === 'top-left').map(ad => (
                        <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='full-size-ad-container'>
                            <img src={default_image_url+ad.path} alt={ad.url} />
                        </a>
                    ))}
                </div>
            </Container>
            :
                ''
            }

            <MostViewedCompanies />
            <NewestCompanies />

            <ExpoLink ads={ads} />

            {/* <Map /> */}
            <Announcements />
            <Gallery />
            <News />

            <Container>
                {ads.filter(item => item.location === 'homepage' & item.position === 'above-contact-form').map(ad => (
                    <a key={ad.id} href={`//${ad.url}`} target='_blank' rel="nofollow" className='home-fullsize-ad'>
                        <img src={default_image_url+ad.path} alt={ad.url} />
                    </a>
                ))}
            </Container>

            <ContactUs />
        </Wrapper>
    )
}

export default Home
